import { AxiosError } from 'axios'

export interface RateLimitInfo {
  isRateLimited: boolean
  retryAfter: number
  limit: number
  remaining: number
  reset: number
  message: string
}

export function parseRateLimitHeaders(error: AxiosError): RateLimitInfo | null {
  if (error.response?.status !== 429) {
    return null
  }

  const headers = error.response.headers
  const retryAfter = parseInt(headers['retry-after'] || '60', 10)
  const limit = parseInt(headers['x-ratelimit-limit'] || '0', 10)
  const remaining = parseInt(headers['x-ratelimit-remaining'] || '0', 10)
  const reset = parseInt(headers['x-ratelimit-reset'] || '0', 10)

  const message = (error.response.data as any)?.message ||
    `Příliš mnoho požadavků. Zkuste to znovu za ${formatRetryTime(retryAfter)}.`

  return {
    isRateLimited: true,
    retryAfter,
    limit,
    remaining,
    reset,
    message
  }
}

export function formatRetryTime(seconds: number): string {
  if (seconds < 60) {
    return `${seconds} sekund`
  }
  const minutes = Math.ceil(seconds / 60)
  if (minutes === 1) {
    return '1 minutu'
  }
  if (minutes < 5) {
    return `${minutes} minuty`
  }
  return `${minutes} minut`
}

// Store for tracking rate limit cooldowns
const rateLimitStore: Map<string, { until: number }> = new Map()

export function isEndpointRateLimited(endpoint: string): boolean {
  const entry = rateLimitStore.get(endpoint)
  if (!entry) return false

  if (Date.now() > entry.until) {
    rateLimitStore.delete(endpoint)
    return false
  }

  return true
}

export function setRateLimitCooldown(endpoint: string, retryAfterSeconds: number): void {
  rateLimitStore.set(endpoint, {
    until: Date.now() + (retryAfterSeconds * 1000)
  })
}

export function getRemainingCooldown(endpoint: string): number {
  const entry = rateLimitStore.get(endpoint)
  if (!entry) return 0

  const remaining = Math.ceil((entry.until - Date.now()) / 1000)
  return Math.max(0, remaining)
}

export function clearRateLimitCooldown(endpoint: string): void {
  rateLimitStore.delete(endpoint)
}
